import { render, staticRenderFns } from "./findExhibitDetail.vue?vue&type=template&id=537d6766&scoped=true"
import script from "./findExhibitDetail.vue?vue&type=script&lang=js"
export * from "./findExhibitDetail.vue?vue&type=script&lang=js"
import style0 from "./findExhibitDetail.vue?vue&type=style&index=0&id=537d6766&prod&lang=stylus"
import style1 from "./findExhibitDetail.vue?vue&type=style&index=1&id=537d6766&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d6766",
  null
  
)

export default component.exports